// src/config/api.js

// Strip any trailing slash so `BASE_URL + '/api/...'` can't produce a
// double slash (`//api/...`), which Flask won't route.
const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://ollamaapi-test.poolbrain.com';

export const API_CONFIG = {
  BASE_URL: RAW_BASE_URL.replace(/\/+$/, ''),
  // Chat queries can legitimately take > 30s on complex multi-JOIN aggregations.
  // Raised from 30000 to 120000 (2 min) to prevent false timeouts.
  TIMEOUT: 120000,
  ENDPOINTS: {
    INVOICE_CHAT: '/api/invoice-chat',
    COMPANIES: '/api/companies',
    CHARTS: '/api/analyze-data-for-charts',
    EXPORT: '/api/export-data',
    // Accuracy Dashboard endpoints
    ACCURACY_DASHBOARD: '/api/accuracy/dashboard',
    ACCURACY_TRENDS: '/api/accuracy/trends',
    ACCURACY_DOMAIN: '/api/accuracy/domain',
    ACCURACY_FEEDBACK: '/api/accuracy/feedback',
    ACCURACY_HALLUCINATIONS: '/api/accuracy/hallucinations',
    ACCURACY_EXPORT: '/api/accuracy/export',
    ACCURACY_HEALTH: '/api/accuracy/health',
    ACCURACY_QUERIES: '/api/accuracy/queries',
    // Admin panel — direct PostgreSQL reads
    ADMIN_FEEDBACK_LIST:  '/api/accuracy/feedback/list',
    ADMIN_QUERY_RECORDS:  '/api/accuracy/pg/query-records',
    ADMIN_HALLUCINATIONS: '/api/accuracy/pg/hallucinations',
    // Feedback cache
    SUBMIT_FEEDBACK: '/api/submit-feedback',
    // Semantic format intelligence
    FORMAT_FEEDBACK: '/api/format-feedback',
    ANALYZE_INTENT: '/api/analyze-intent',
  }
};
